import type { CurationDecision, RelationType } from '../api/knowledgeApi'

/** How a typed relation reads from source to target, and from the target's side. */
export const RELATION_LABEL: Record<RelationType, string> = {
  broader_than: 'broader than',
  variant_of: 'variant of',
  opposite_of: 'opposite of',
  related_to: 'related to',
}
export const RELATION_INVERSE_LABEL: Record<RelationType, string> = {
  broader_than: 'narrower than',
  variant_of: 'has variant',
  opposite_of: 'opposite of',
  related_to: 'related to',
}

// Weight presets offered next to "Automatic" (rarity-based specificity).
export const WEIGHTS = [
  { value: 0.1, label: 'Generic — barely counts (0.1)' },
  { value: 0.5, label: 'Half (0.5)' },
  { value: 1, label: 'Full (1.0)' },
]

/** One-line description of a structural rule. */
export function describeRule(rule: CurationDecision): string {
  const p = rule.payload as { conceptNames?: string[]; conceptName?: string; groups?: string[][]; names?: string[] }
  if (rule.action === 'merge') return `Merge ${(p.conceptNames ?? []).map((n) => `“${n}”`).join(' + ')}`
  if (rule.action === 'separate') return `Split ${(p.groups?.[1] ?? []).map((n) => `“${n}”`).join(', ')} off “${p.conceptName ?? ''}”`
  if (rule.action === 'reject') return `Remove “${p.conceptName ?? ''}” from the graph`
  return rule.action
}
